import schema from '../../AdicionarBeneficiario/Titular/schema';

import { cloneObject, addMaskCellphone, addMaskCpf, addMaskSus, addMaskPis } from '../../../../utils';

function inclusaoTitular(form) {
    const { form: titular } = form;

    const dadosTitular = cloneObject(schema);

    dadosTitular.address.value = titular.nomeLogradouro;
    dadosTitular.addressNumber.value = titular.numeroEndereco;
    dadosTitular.admissionDate.value = titular.dataAdmissao;
    dadosTitular.birth.value = titular.dataNascimento;
    dadosTitular.capacity.codigoTS = titular.codigoLotacaoTS;
    dadosTitular.capacity.value = titular.codigoLotacao;
    dadosTitular.capacity.lookup = titular.nomeLotacao;
    dadosTitular.cardNumber.value = '';
    dadosTitular.cellphone.value =
        titular.numeroTelefone && addMaskCellphone(`${titular.numeroDddTelefone}${titular.numeroTelefone}`);
    dadosTitular.cellphone.unmaskedValue =
        titular.numeroTelefone && `(${titular.numeroDddTelefone}) ${titular.numeroTelefone}`;
    dadosTitular.cep.value = titular.numeroCep;
    dadosTitular.cep.unmaskedValue = titular.numeroCep;
    dadosTitular.city.value = titular.codigoMunicipio;
    dadosTitular.city.lookup = titular.nomeCidade;
    dadosTitular.civilState.value = titular.estadoCivil;
    dadosTitular.civilState.unmaskedValue = titular.nomeEstadoCivil;
    dadosTitular.company.value = titular.codigoEmpresa;
    dadosTitular.company.lookup = titular.nomeEmpresa;
    dadosTitular.complement.value = titular.complementoEndereco;
    dadosTitular.costCenter.value = titular.codigoLocalTS; // lookup feito ao carregar tela
    dadosTitular.countyService.value = titular.codigoMunicipioAtendimento;
    dadosTitular.countyService.lookup = titular.nomeMunicipioAtendimento;
    dadosTitular.countyService.options = [
        {
            codigo: titular.codigoMunicipioAtendimento,
            nome: titular.nomeMunicipioAtendimento,
        },
    ];
    dadosTitular.cpf.value = addMaskCpf(titular.numeroCPF);
    dadosTitular.cpf.unmaskedValue = titular.numeroCPF;
    dadosTitular.dateStartPlan.value = titular.dataInclusao;
    dadosTitular.dn.value = titular.numeroDeclaracaoNascidoVivo;
    dadosTitular.email.value = titular.enderecoEmail;
    dadosTitular.enrollmentSequence.value = titular.numeroSequencialMatricula;
    dadosTitular.fullName.value = titular.nomeAssociado;
    dadosTitular.functionalEnrollment.value = titular.numeroMatriculaNaEmpresa;
    dadosTitular.functionalStatus.value = titular.situacaoNaEmpresa;
    dadosTitular.functionalStatus.lookup = titular.descricaoSituacaoNaEmpresa;
    dadosTitular.gender.value = titular.sexo;
    dadosTitular.gender.lookup = titular.sexo && (titular.sexo === 'M' ? 'Masculino' : 'Feminino');
    dadosTitular.healthPlan.value = titular.codigoPlano;
    dadosTitular.healthPlan.lookup = titular.nomePlano;
    dadosTitular.height.value = '';
    dadosTitular.hood.value = titular.nomeBairro;
    dadosTitular.motherName.value = titular.nomeMae;
    dadosTitular.nationality.value = titular.nacionalidade;
    dadosTitular.nationality.lookup =
        titular.nacionalidade && (titular.nacionalidade === 'B' ? 'Brasileira' : 'Estrangeira');
    dadosTitular.occupation.value = titular.codigoCargo; // lookup feito ao carregar tela
    dadosTitular.pis.value = addMaskPis(titular.numeroPIS);
    dadosTitular.pis.unmaskedValue = titular.numeroPIS;
    dadosTitular.socialName.value = titular.nomeSocial;
    dadosTitular.startCapacity.value = titular.dataLotacao;
    dadosTitular.startDate.value = titular.dataInicioContribuicao;
    // dadosTitular.stateService.value = titular.a; n retorna
    dadosTitular.sus.value = addMaskSus(titular.numeroUnicoSaude);
    dadosTitular.sus.unmaskedValue = titular.numeroUnicoSaude;
    dadosTitular.uf.value = titular.siglaUF;
    dadosTitular.uf.lookup = titular.siglaUF;
    dadosTitular.weight.value = titular.peso;
    dadosTitular.height.value = titular.altura;

    return dadosTitular;
}

export { inclusaoTitular };
